import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CanyonRecordAccordion from '../canyons/CanyonRecordAccordion';
import * as EquipmentDataStore from '../../helpers/data/EquipmentDataStore';
import { useCanyonRecords } from '../../hooks/useCanyonRecords';
import { useTranslation } from 'react-i18next';
import Loader from '../Loader';

interface RopeServiceDescentsProps {
  ropeId: number;
}

const RopeDescentHistory: React.FC<RopeServiceDescentsProps> = ({ ropeId }) => {
  const { t } = useTranslation();
  const [sectionOpen, setSectionOpen] = useState<number | null>(null);

  const { canyonsById, userCanyonsById, isLoading, records } = useCanyonRecords(
    () => EquipmentDataStore.loadRopeDescents(ropeId),
    true
  );

  function handleAccordionToggle(id: number | null) {
    setSectionOpen(prev => prev === id ? null : id);
  }

  return (
    <Loader isLoading={isLoading} >
      <Box>
        {records.length > 0 ? records.map(rec => {
          const canyon = rec.CanyonId
            ? canyonsById[rec.CanyonId]
            : rec.UserCanyonId
              ? userCanyonsById[rec.UserCanyonId]
              : undefined

          if (!canyon) {
            return null;
          }

          return <CanyonRecordAccordion
key={rec.Id ?? rec.Timestamp ?? `${rec.Name}-${rec.Date}`}
            isOpen={sectionOpen === rec.Id}
            onChange={() => handleAccordionToggle(rec.Id ?? null)}
            record={rec}
            canyon={canyon}
          />
        }) : <Typography sx={{ p: 2, fontStyle: 'italic' }}>
          {t('journal.noRecords')}
        </Typography>}
      </Box>
    </Loader>
  );
};

export default RopeDescentHistory;
